module.exports = __webpack_public_path__ + "static/media/logoRoute.509831bd.svg";